import { User } from "@/model/api/User";

export interface AuthState {
    me: User;
}

const state: AuthState = {
    me: null,
};

export default state;